import { useState, useRef, type ReactNode } from 'react'
import { createPortal } from 'react-dom'

interface TooltipProps {
  label: string
  children: ReactNode
}

export default function Tooltip({ label, children }: TooltipProps) {
  const [visible, setVisible] = useState(false)
  const [pos, setPos] = useState({ top: 0, left: 0 })
  const ref = useRef<HTMLDivElement>(null)

  const show = () => {
    if (ref.current) {
      const rect = ref.current.getBoundingClientRect()
      setPos({
        top: rect.top + rect.height / 2,
        left: rect.right + 12,
      })
    }
    setVisible(true)
  }

  const hide = () => setVisible(false)

  return (
    <div
      ref={ref}
      onMouseEnter={show}
      onMouseLeave={hide}
    >
      {children}
      {visible && createPortal(
        <div
          className="fixed px-3 py-1.5 bg-black text-white text-sm font-semibold rounded-md shadow-xl pointer-events-none whitespace-nowrap animate-fade-in"
          style={{
            top: pos.top,
            left: pos.left,
            transform: 'translateY(-50%)',
            zIndex: 99999,
          }}
        >
          {label}
        </div>,
        document.body
      )}
    </div>
  )
}
